import React, { createContext, useContext, useState } from 'react';

interface LowCreditsContextType {
  lowCredits: boolean;
  setLowCredits: (value: boolean) => void;
}

const LowCreditsContext = createContext<LowCreditsContextType | undefined>(undefined);

export const LowCreditsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lowCredits, setLowCredits] = useState(false);
  return (
    <LowCreditsContext.Provider value={{ lowCredits, setLowCredits }}>
      {children}
    </LowCreditsContext.Provider>
  );
};

export function useLowCredits() {
  const context = useContext(LowCreditsContext);
  if (!context) throw new Error('useLowCredits must be used within a LowCreditsProvider');
  return context;
} 